import _ from 'lodash'
import Generic from './generic'

class Region extends Generic {
  get isCity() { return this.considered_city }
}

export default Region
